import tenantPayloads from '@payloads';
import tenantTransformers from '@transformers';
import { convertQueryObjToString } from '../../../utility/urlQuery';
import store from '@store';
import tenantData from '@data';
import tenantUtils from '@utils';
import { convertArrayToQueryString, mapQueryParams } from '../../../utility/utility';

const dataMapper = (obj) => {
  const productsHash = {};
  tenantData.products.forEach((e) => {
    productsHash[e.slug] = e;
  });
  return obj.map((item) => {
    return {
      ...item,
      icon: productsHash[item?.product?.slug]?.icon,
      iconColor: productsHash[item?.product?.slug]?.iconColor,
      iconProps: productsHash[item?.product?.slug]?.iconProps,
      appliedDate: item?.performed_at,
      expiryDate: item?.listing?.expiry_date,
    };
  });
};

const summaryDataMapper = (e) => {
  const productsHash = {};
  tenantData.products.forEach((e) => {
    productsHash[e.slug] = e;
  });

  const by_products = e?.consumption_summary?.map((item) => {
    return {
      ...item,
      icon: productsHash[item.slug]?.icon,
      iconColor: productsHash[item.slug]?.iconColor,
      used_credits: item.consume_credits,
    };
  });

  let endPoint = 0;
  let lineChartData = '90deg';
  const totalUsed = e?.used;

  let startPoint = 0;
  e?.consumption_summary?.forEach((e) => {
    endPoint = endPoint + (e.consume_credits / totalUsed) * 100;
    if (productsHash[e?.slug]) {
      lineChartData += ', ' + productsHash[e?.slug]?.iconColor + ' ' + startPoint + '% ' + endPoint + '%';
    }
    startPoint = endPoint;
  });
  lineChartData = `linear-gradient(${lineChartData})`;
  const totalUsedCredits = by_products.reduce((acc, item) => acc + item.used_credits, 0);

  const chartData = {
    datasets: [
      {
        data: by_products.map((item) => item.used_credits),
        backgroundColor: by_products.map((item) => item.iconColor || 'rgba(0, 0, 0, 0.2)'),
      },
    ],
    total: totalUsedCredits,
    labels: by_products.map((item) => tenantUtils.getLocalisedString(item, 'title')),
  };

  const res = {
    details: [
      { label: 'Available', value: e?.available },
      { label: 'Used', value: e?.used },
      { label: 'Total', value: e?.total },
    ],
    by_products: by_products,
    chartData: chartData,
    lineChartData: lineChartData,
  };
  return res;
};

const quotaCreditsApiEndpoints = {
  getCreditDeduction: {
    query: ({ listingId }) => {
      return {
        url: `/api/products/applicable_products?listing_id=${listingId}`,
      };
    },
    transformer: (response) => {
      const products = response?.data?.products;
      if (products?.length) {
        // const applicable_produduct = products?.find((e) => e?.product_id == productId);
        return {
          // [platform]: {
          //   available: 100,
          //   required: applicable_produduct?.credits_required?.['30'],
          //   isZoneArea: false,
          //   zoneFactor: 1,
          //   totalQuota: 100,
          // },
        };
      }
    },
  },
  transferCredits: {
    query: (body) => ({
      url: `/api/credits/transfer`,
      method: 'POST',
      body: tenantPayloads.transferQuotaCreditsPayload(body),
    }),
  },
  getQuotaCreditsForTransfer: {
    query: (query) => ({
      url: `/api/dashboard/qc_summary?${convertQueryObjToString(query)}`,
    }),
    transformer: (response) => tenantTransformers.manageTransferQuotaCreditsTransformer(response),
  },
  transferQuota: {
    query: (body) => ({
      url: `/api/quotas/transfer`,
      method: 'POST',
      body: tenantPayloads.transferQuotaCreditsPayload(body),
    }),
  },
  getQuotaCreditsWidgetData: {
    query: ({ platform_id, ...rest }) => {
      const user = store.getState().app.loginUser.user;

      return {
        url: user?.isCurrencyUser
          ? `/api/credits/summary?${convertQueryObjToString(rest)}&${convertArrayToQueryString(platform_id, 'platform_ids')}`
          : `/api/dashboard/qc_summary?${convertQueryObjToString(rest)}`,
      };
    },
    transformer: (response, combineCredits) => {
      const user = store.getState().app.loginUser.user;
      if (user?.isCurrencyUser) {
        return tenantTransformers.creditsWidgetMapper(response, combineCredits);
      }
    },
  },

  getCustomCreditsPrice: {
    query: (queryParams) => {
      return { url: `api/packages/calculate_price?${convertQueryObjToString(queryParams)}` };
    },
    transformer: (response) => tenantTransformers.customCreditsPriceDataMapper(response),
  },

  getConsumptionHistoryData: {
    query: ({ page, params, filtersList }) => {
      const mappedParams = mapQueryParams(params, filtersList);
      return { url: `/api/credits/consumption_history?page=${page || 1}&${mappedParams}` };
    },
    transformer: (response, meta, { platforms }) => {
      let data = {};
      platforms?.forEach((platform) => {
        const platformSlug = platform?.slug;
        const platformData = response?.credits_consumption_history?.[platformSlug];

        if (platformData) {
          data[platformSlug] = {
            data: dataMapper(platformData),
            pagination: response?.pagination,
          };
        }
      });

      return data;
    },
  },
  getConsumptionSummaryData: {
    query: () => {
      return { url: `/api/credits/consumption_summary` };
    },
    transformer: (response, meta, { platforms }) => {
      let responses = {};
      platforms?.map((platform) => {
        if (response?.credits_consumption_summary?.[platform?.slug]) {
          responses[platform?.slug] = summaryDataMapper(response?.credits_consumption_summary?.[platform?.slug]);
        }
      });
      return responses;
    },
  },
};

export default quotaCreditsApiEndpoints;
